import { LOCALES } from "../../common/constants";

export const questions = [
  {
    q: 'FAQ_1_QUESTION',
    a: ['FAQ_1_ANSWER_1',
      'FAQ_1_ANSWER_2',
      'FAQ_1_ANSWER_3']
  },
  {
    q: 'FAQ_2_QUESTION',
    a: ['FAQ_2_ANSWER_1',
      'FAQ_2_ANSWER_2',
      'FAQ_2_ANSWER_3']
  },
  { q: 'FAQ_4_QUESTION', a: ['FAQ_4_ANSWER_1', 'FAQ_4_ANSWER_2', 'FAQ_4_ANSWER_3'] },
  { q: 'FAQ_5_QUESTION', a: ['FAQ_5_ANSWER_1'] },
];
const revolutReferralUrl = "https://revolut.com/referral/?referral-code=kevindtxd!JUN1-25-AR-H2&geo-redirect=";

export const ABOUT_INVOZIO_REDIRECT = "ABOUT_INVOZIO_REDIRECT";

export const getAboutInvozioRedirect = (lang: string) =>
  lang === LOCALES.EN_US
    ? `https://www.invozio.com/about-invozio?lang=${LOCALES.EN_US}`
    : `https://www.invozio.com/om-invozio?lang=${LOCALES.SV_SE}`;

interface FAQItem {
  id: string;
  question: string;
  answer: string;
  category: 'general' | 'login' | 'features' | 'pension';
  // Optional override for the FAQ page's keyword-derived display category
  faqCategory?: 'invoicing' | 'payments' | 'taxes' | 'account';
  para1?: React.ReactNode;
  para2?: React.ReactNode;
  para3?: React.ReactNode;
  para4?: React.ReactNode;
  para5?: React.ReactNode;
  para6?: React.ReactNode;
  para7?: React.ReactNode;
  para8?: React.ReactNode;
  para9?: React.ReactNode;
  para10?: React.ReactNode;
  li1?: string[];
  li2?: string[];
  heading1?: string;
  heading2?: string;
  heading?: string;
  head?: string;
  subDescription?: string;
  supportEmail?: string;
  supportEmail1?: string;
  supportEmail2?: string;
  support?: string;
  support1?: string;
  support2?: string;
  link?: string;
  redirect?: string;
  span?: string;
  optionalLinks?: Array<{
    link: string;
    redirect: string;
  }>;
}

interface FAQItemExtended {
  title: string;
  description: string;
  para1?: string;
  para2?: string;
  para3?: string;
  para4?: string;
  para5?: string;
  para6?: string;
  para7?: string;
  para8?: string;
  para9?: string;
  para10?: string;
  li1?: string[];
  li2?: string[];
  heading1?: string;
  heading2?: string;
  heading?: string;
  head?: string;
  subDescription?: string;
  supportEmail?: string;
  supportEmail1?: string;
  supportEmail2?: string;
  support?: string;
  support1?: string;
  support2?: string;
  link?: string;
  redirect?: string;
  image?: any;
  span?: string;
  optionalLinks?: Array<{
    link: string;
    redirect: string;
  }>;
}

export const faqData: FAQItem[] = [
  {
    id: '1',
    question: 'FAQ_TAX_FREE_EXPENSE_QUESTION',
    answer: 'FAQ_TAX_FREE_EXPENSE_ANSWER',
    category: 'general',
    para1: 'FAQ_TAX_FREE_EXPENSE_PARA1',
    para2: 'FAQ_TAX_FREE_EXPENSE_PARA2',
    para3: 'FAQ_TAX_FREE_EXPENSE_PARA3',
    li1: [
      'FAQ_TAX_FREE_EXPENSE_LI1_1',
      'FAQ_TAX_FREE_EXPENSE_LI1_2',
      'FAQ_TAX_FREE_EXPENSE_LI1_3'
    ]
  },
  {
    id: '2',
    question: 'FAQ_INVOICE_PAID_QUESTION',
    answer: 'FAQ_INVOICE_PAID_ANSWER_PARA_1',
    para1: 'FAQ_INVOICE_PAID_ANSWER_PARA_2',
    para2: 'FAQ_INVOICE_PAID_ANSWER_PARA_3',

    category: 'general'
  },
  
  {
    id: '4',
    question: 'FAQ_EXPENSE_DEDUCTION_QUESTION',
    answer: 'FAQ_3_ANSWER_1',
    para1: 'FAQ_3_ANSWER_PARA1',
    para2: 'FAQ_3_ANSWER_PARA2',
    li1: [
      'FAQ_3_ANSWER_LINE1',
      'FAQ_3_ANSWER_LINE2',
      'FAQ_3_ANSWER_LINE3',
      // 'FAQ_3_ANSWER_LINE4'
    ],
    category: 'general'
  },
  {
    id: '5',
    question: 'FAQ_UNEMPLOYMENT_BENEFITS_QUESTION',
    answer: 'FAQ_5_ANSWER_PARA_1',
    para1: 'FAQ_5_ANSWER_PARA_2',
    para2: 'FAQ_5_ANSWER_PARA_3',
    para3: 'FAQ_5_ANSWER_PARA_4',
    category: 'general'
  },
  {
    id: '6',
    question: 'FAQ_ADVANCE_REGISTRATION_QUESTION',
    answer: 'FOLLOW_THE_STEPS_BELOW',
    heading1: 'LOG_IN_TO_YOUR_ACCOUNT_AND_GO_TO_YOUR_DASHBOARD',
    para1: "NAVIGATE_TO_ASSIGNMENT_REGISTRATION_IN_THE_SIDEBAR",
    para2: "CLICK_ON_REGISTER_NEW_ASSIGNMENT",
    para3: 'FILL_IN_THE_REQUIRED_DETAILS',
    para4: "REVIEW_AND_CLICK_REGISTER",
    para5: 'CONFIRMATION_AFTER_SUBMISSION',
    para6: "CREATE_INVOICE_WHEN_READY",
    category: 'general'
  },
  {
    id: '7',
    question: 'FAQ_CONDITIONS_QUESTION',
    answer: 'FAQ_CONDITIONS_ANSWER',
    category: 'general'
  },
  {
    id: '8',
    question: 'FAQ_INVOICE_WITHOUT_VAT_QUESTION',
    answer: 'Yes, you can invoice without VAT, but we will ensure that you have selected the correct VAT when we send out your invoices. In special cases such as reverse VAT for construction or when invoicing abroad, our platform will automatically change to reverse VAT at 0%, as long as you register your customer in the correct category or country on our platform.',
    category: 'general'
  },

  {
    id: '9',
    question: 'FAQ_AGREEMENT_QUESTION',
    answer: 'The agreement consists of accepting the general terms and conditions of employment at invoicing, with no commitments beyond that. The rights and obligations between you and Invozio are governed by your approving an invoice.',
    category: 'general'
  },
  {
    id: '10',
    question: 'FAQ_ILLNESS_QUESTION',
    answer: 'SICK_POLICY_INVOZIO_ANSWER',
    para1: 'SICK_POLICY_INVOZIO_ANSWER_PARA_1',

    para2: 'If you are still ill after 14 days, Invozio will register your illness with the Swedish Social Insurance Agency. After that, you can apply for sickness benefits from Försäkringskassan.',
    category: 'general'
  },
  {
    id: '11',
    question: 'FAQ_PAYPAL_QUESTION',
    answer: 'No, but they can use any account that accept IBAN-payment.',
    category: 'general'
  },
  {
    id: '12',
    question: 'FAQ_CUSTOM_LOGO_QUESTION',
    answer: 'FAQ_CUSTOM_LOGO_ANSWER',
    category: 'general'
  },
  {
    id: '13',
    question: 'FAQ_AGREEMENT_CLIENT_QUESTION',
    answer: 'We do not require a formal agreement',
    category: 'general'
  },
  {
    id: '14',
    question: 'FAQ_SEND_INVOICES_QUESTION',
    answer: 'FAQ_SEND_INVOICES_ANSWER',
    category: 'general'
  },

  {
    id: '15',
    question: 'FAQ_RECEIVE_SALARY_QUESTION',
    answer: 'FAQ_RECEIVE_SALARY_ANSWER',
    category: 'general',
    para1: 'FAQ_RECEIVE_SALARY_PARA1',
    para2: 'FAQ_RECEIVE_SALARY_PARA2',
    para3: 'FAQ_RECEIVE_SALARY_PARA3'
  },
  {
    id: '16',
    question: 'FAQ_INVOICE_LIMIT_QUESTION',
    answer: 'FAQ_INVOICE_LIMIT_ANSWER',
    category: 'general'
  },
  {
    id: '17',
    question: 'FAQ_BANK_DETAILS_FILL_QUESTION',
    answer: 'FAQ_BANK_DETAILS_FILL_ANSWER',
    category: 'general'
  },
  {
    id: '18',
    question: 'FAQ_CREDIT_HISTORY_QUESTION',
    answer: 'FAQ_CREDIT_HISTORY_ANSWER',
    category: 'general'
  },
  {
    id: '19',
    question: 'FAQ_LIVE_ARTIST_VAT_QUESTION',
    answer: 'FAQ_LIVE_ARTIST_VAT_ANSWER_PARA_1',
    para1: 'FAQ_LIVE_ARTIST_VAT_ANSWER_PARA_2',
    para2: 'FAQ_LIVE_ARTIST_VAT_ANSWER_PARA_3',
    category: 'general'
  },
  {
    id: '20',
    question: 'FAQ_REGISTER_ASSIGNMENTS_QUESTION',
    answer: 'FAQ_REGISTER_ASSIGNMENTS_ANSWER',
    category: 'general',
    para1: 'FAQ_REGISTER_ASSIGNMENTS_PARA1',
    supportEmail: 'support@invozio.com.',
    // support: 'support@invozio.com',
    para2: 'FAQ_REGISTER_ASSIGNMENTS_PARA2',
  },
  {
    id: '21',
    question: 'FAQ_CALCULATE_PAY_QUESTION',
    answer: 'FAQ_CALCULATE_PAY_ANSWER',
    category: 'general'
  },
  {
    id: '22',
    question: 'FAQ_REGISTER_SERVICE_QUESTION',
    answer: 'FAQ_REGISTER_SERVICE_ANSWER',
    category: 'general'
  },
  {
    id: '23',
    question: 'FAQ_CUSTOMER_RECEIVE_INVOICE_QUESTION',
    answer: 'FAQ_CUSTOMER_RECEIVE_INVOICE_ANSWER',
    category: 'general'
  },
  {
    id: '24',
    question: 'FAQ_CREDIT_INVOICE_QUESTION',
    answer: 'FAQ_CREDIT_INVOICE_ANSWER',
    para2: 'FAQ_CREDIT_INVOICE_ANSWER_PARA2',
    para3: 'FAQ_CREDIT_INVOICE_ANSWER_PARA3',
    para4: 'FAQ_CREDIT_INVOICE_ANSWER_PARA4',

     li1: [
      'FAQ_CREDIT_INVOICE_ANSWER_PARA5',
       'FAQ_CREDIT_INVOICE_ANSWER_PARA6'
     ],
      category: 'general'
  },
  {
    id: '25',
    question: 'FAQ_INVOICE_ERROR_QUESTION',
    answer: 'FAQ_INVOICE_ERROR_ANSWER',
    para1: "FAQ_INVOICE_ERROR_ANSWER_PARA1",
    para2: "FAQ_INVOICE_ERROR_ANSWER_PARA2",
    category: 'general'
  },
  {
    id: '26',
    question: 'FAQ_UNPAID_INVOICE_QUESTION',
    answer: 'FAQ_UNPAID_INVOICE_ANSWER',
    category: 'general',
    para1: 'FAQ_UNPAID_INVOICE_PARA1',
    para2: 'FAQ_UNPAID_INVOICE_PARA2',
    para3: 'FAQ_UNPAID_INVOICE_PARA3',
    para4: 'FAQ_UNPAID_INVOICE_PARA4',
    para5: 'FAQ_UNPAID_INVOICE_PARA5',
    para6: 'FAQ_UNPAID_INVOICE_PARA6',
    para7: 'FAQ_UNPAID_INVOICE_PARA7'
  },
  {
    id: '27',
    question: 'FAQ_SOCIAL_SECURITY_QUESTION',
    answer: 'FAQ_SOCIAL_SECURITY_ANSWER',
    para1: 'FAQ_SOCIAL_SECURITY_ANSWER_PARA_1',
    category: 'general'
  },
  {
    id: '28',
    question: 'FAQ_VAT_RATE_QUESTION',
    answer: 'FAQ_VAT_RATE_ANSWER',
    category: 'general',
    link: "www.skatteverket.se",
    redirect: "https://www.skatteverket.se/foretagorganisationer/moms/saljavarorochtjanster/momspavarorochtjanster.4.58d555751259e4d66168000409.html"
  },
  {
    id: '29',
    question: 'FAQ_INSURANCE_TERMS_QUESTION',
    answer: 'FAQ_INSURANCE_TERMS_ANSWER',
    category: 'general',
    para1: 'FAQ_INSURANCE_TERMS_PARA1',
    para2: 'FAQ_INSURANCE_TERMS_PARA2',
    para3: 'FAQ_INSURANCE_TERMS_PARA3',
    link: "ABOUT_INVOZIO",
    redirect: ABOUT_INVOZIO_REDIRECT,
  },
  {
    id: '30',
    question: 'FAQ_EMPLOYMENT_CERTIFICATE_QUESTION',
    answer: 'FAQ_EMPLOYMENT_CERTIFICATE_ANSWER',
    para1: 'FAQ_EMPLOYMENT_CERTIFICATE_PARA1',
    para2: 'FAQ_EMPLOYMENT_CERTIFICATE_PARA2',
    para3: 'FAQ_EMPLOYMENT_CERTIFICATE_PARA3',
    para4: 'FAQ_EMPLOYMENT_CERTIFICATE_PARA4',
    li1: [
      'FAQ_EMPLOYMENT_CERTIFICATE_LI1_1',
      'FAQ_EMPLOYMENT_CERTIFICATE_LI1_2',
      'FAQ_EMPLOYMENT_CERTIFICATE_LI1_3',
      'FAQ_EMPLOYMENT_CERTIFICATE_LI1_4'
    ],
    para5: 'FAQ_EMPLOYMENT_CERTIFICATE_PARA5',
    para6: 'FAQ_EMPLOYMENT_CERTIFICATE_PARA6',
    li2: [
      'FAQ_EMPLOYMENT_CERTIFICATE_LI2_1',
      'FAQ_EMPLOYMENT_CERTIFICATE_LI2_2',
      'FAQ_EMPLOYMENT_CERTIFICATE_LI2_3'
    ],
    para7: 'FAQ_EMPLOYMENT_CERTIFICATE_PARA7',
    para8: 'FAQ_EMPLOYMENT_CERTIFICATE_PARA8',
    para9: 'FAQ_EMPLOYMENT_CERTIFICATE_PARA9',
    para10: 'FAQ_EMPLOYMENT_CERTIFICATE_PARA10',
    category: 'general'
  },
  {
    id: '31',
    question: 'FAQ_WORKING_HOURS_QUESTION',
    answer: 'FAQ_WORKING_HOURS_ANSWER_PARA_1',
    para1:'FAQ_WORKING_HOURS_ANSWER_PARA_2',
    category: 'general'
  },
  {
    id: '32',
    question: 'FAQ_AGE_LIMIT_QUESTION',
    answer: 'FAQ_AGE_LIMIT_ANSWER',
    category: 'general',
    supportEmail: 'support@invozio.com.',
    // support: '"mailto:support@invozio.com',
    para2: 'FAQ_AGE_LIMIT_PARA2'
  },
  {
    id: '33',
    question: 'FAQ_EMPLOYER_CONTRIBUTIONS_67_QUESTION',
    answer: 'FAQ_EMPLOYER_CONTRIBUTIONS_67_ANSWER',
    category: 'general'
  },
  {
    id: '35',
    question: 'FAQ_ACCOUNT_DEACTIVATED_QUESTION',
    answer: 'FAQ_ACCOUNT_DEACTIVATED_ANSWER',
    category: 'general',
    supportEmail: 'support@invozio.com.',
    support: 'support@invozio.com.',
    para2: 'FAQ_ACCOUNT_DEACTIVATED_PARA2'
  },
  {
    id: '36',
    question: 'FAQ_CONTRACT_DETAILS_QUESTION',
    answer: 'FAQ_CONTRACT_DETAILS_ANSWER',
    category: 'general',
    para1: 'FAQ_CONTRACT_DETAILS_PARA1',
    li1: [
      'FAQ_CONTRACT_DETAILS_LI1_1',
      'FAQ_CONTRACT_DETAILS_LI1_2',
      'FAQ_CONTRACT_DETAILS_LI1_3',
      'FAQ_CONTRACT_DETAILS_LI1_4',
      'FAQ_CONTRACT_DETAILS_LI1_5',
      'FAQ_CONTRACT_DETAILS_LI1_6',
      'FAQ_CONTRACT_DETAILS_LI1_7',
      'FAQ_CONTRACT_DETAILS_LI1_8',
      'FAQ_CONTRACT_DETAILS_LI1_9',
      'FAQ_CONTRACT_DETAILS_LI1_10',
      'FAQ_CONTRACT_DETAILS_LI1_11'
    ],
    head: 'FAQ_CONTRACT_DETAILS_HEAD',
    li2: [
      'FAQ_CONTRACT_DETAILS_LI2_1',
      'FAQ_CONTRACT_DETAILS_LI2_2',
      'FAQ_CONTRACT_DETAILS_LI2_3',
      'FAQ_CONTRACT_DETAILS_LI2_4',
      'FAQ_CONTRACT_DETAILS_LI2_5'
    ]
  },
  {
    id: '37',
    question: 'FAQ_ROT_RUT_INVOICE_QUESTION',
    answer: 'FAQ_ROT_RUT_INVOICE_ANSWER',
    category: 'general',
    para1: 'FAQ_ROT_RUT_INVOICE_PARA1',
    li1: [
      'FAQ_ROT_RUT_INVOICE_LI1_1',
      'FAQ_ROT_RUT_INVOICE_LI1_2',
      'FAQ_ROT_RUT_INVOICE_LI1_3',
      'FAQ_ROT_RUT_INVOICE_LI1_4',
      'FAQ_ROT_RUT_INVOICE_LI1_5',
      'FAQ_ROT_RUT_INVOICE_LI1_6',
      'FAQ_ROT_RUT_INVOICE_LI1_7'
    ]
  },
  {
    id: '38',
    question: 'FAQ_REVOLUT_SWITCH_QUESTION',
    answer: 'We have chosen to switch from Danske Bank to Revolut Bank to improve stability and reduce the risk of technical disruptions that previously affected our users. Revolut offers modern, digital, and internationally recognized banking solutions that align with our operations and the needs of our customers.',
    category: 'general'
  },
  {
    id: '39',
    question: 'FAQ_REVOLUT_TRUSTED_QUESTION',
    answer: 'FAQ_REVOLUT_TRUSTED_ANSWER',
    category: 'general'
  },
  {
    id: '40',
    question: 'FAQ_REVOLUT_SIZE_QUESTION',
    answer: 'FAQ_REVOLUT_SIZE_ANSWER',
    category: 'general',
    li1: [
      'FAQ_REVOLUT_SIZE_LI1_1',
      'FAQ_REVOLUT_SIZE_LI1_2',
      'FAQ_REVOLUT_SIZE_LI1_3',
      'FAQ_REVOLUT_SIZE_LI1_4',
      'FAQ_REVOLUT_SIZE_LI1_5',
      'FAQ_REVOLUT_SIZE_LI1_6'
    ]
  },
  {
    id: '41',
    question: 'FAQ_REVOLUT_USER_IMPACT_QUESTION',
    answer: 'FAQ_REVOLUT_USER_IMPACT_ANSWER',
    category: 'general'
  },
  {
    id: '42',
    question: 'FAQ_NOT_SWEDISH_BANK_QUESTION',
    answer: 'FAQ_NOT_SWEDISH_BANK_ANSWER',
    category: 'general'
  },
  {
    id: '43',
    question: 'FAQ_CORRECT_ACCOUNT_QUESTION',
    answer: 'FAQ_CORRECT_ACCOUNT_ANSWER',
    category: 'general'
  },
  {
    id: '44',
    question: 'FAQ_CUSTOMER_ACTION_QUESTION',
    answer: 'FAQ_CUSTOMER_ACTION_ANSWER',
    category: 'general',
    li1: [
      'FAQ_CUSTOMER_ACTION_LI1_1',
      'FAQ_CUSTOMER_ACTION_LI1_2',
      'FAQ_CUSTOMER_ACTION_LI1_3',
      'FAQ_CUSTOMER_ACTION_LI1_4'
    ]
  },
  {
    id: '45',
    question: 'FAQ_COMMISSION_INVOICE_QUESTION',
    answer: 'FAQ_COMMISSION_INVOICE_ANSWER',
    category: 'general'
  },
  {
    id: '46',
    question: 'FAQ_CONSOLIDATED_INVOICE_QUESTION',
    answer: 'FAQ_CONSOLIDATED_INVOICE_ANSWER',
    para1: 'FAQ_CONSOLIDATED_INVOICE_PARA1',
    li1: [
      'FAQ_CONSOLIDATED_INVOICE_LI1_1',
      'FAQ_CONSOLIDATED_INVOICE_LI1_2',
      'FAQ_CONSOLIDATED_INVOICE_LI1_3',
      'FAQ_CONSOLIDATED_INVOICE_LI1_4'
    ],
    para4: 'FAQ_CONSOLIDATED_INVOICE_PARA2',
    category: 'general'
  },
  {
    id: '47',
    question: 'FAQ_PAID_FASTER_QUESTION',
    answer: 'FAQ_PAID_FASTER_ANSWER',
    para1: "SIGN UP FOR REVOLUT TO ENJOY FASTER PAYMENTS AND FEWER BANKING DELAYS",
    link: 'Click here to sign up for Revolut',
    redirect: revolutReferralUrl,
    category: 'general'
  },
  {
    id: '48',
    question: 'FAQ_EMAIL_CHANGE_QUESTION',
    answer: 'FAQ_EMAIL_CHANGE_ANSWER',
    para1: 'FAQ_EMAIL_CHANGE_ANSWER_PARA1',
    category: 'login'
  },

  {
    id: '52',
    question: 'FAQ_CHANGE_TAX_RATE_QUESTION',
    answer: 'FAQ_CHANGE_TAX_RATE_ANSWER',
    category: 'general',
    
  },
  {
    id: '53',
    question: 'FAQ_FORGOT_PASSWORD_LOGIN_QUESTION',
    answer: 'FAQ_FORGOT_PASSWORD_LOGIN_ANSWER',
    category: 'login'
  },
  {
    id: '54',
    question: 'FAQ_CLIENT_PAID_NO_SALARY_ALT_QUESTION',
    answer: 'FAQ_CLIENT_PAID_NO_SALARY_ALT_ANSWER',
    category: 'general'
  },

   {
    id: '56',
    question: 'EDIT_AN_INVOICE',
    answer: 'EDIT_AN_INVOICE_ANSWER',
     para1: 'EDIT_AN_INVOICE_PARA1',
     li1: [
      'EDIT_AN_INVOICE_PARA2',
      'EDIT_AN_INVOICE_PARA3',
      'EDIT_AN_INVOICE_PARA10',
      'EDIT_AN_INVOICE_PARA4',
     ],
       para5: 'EDIT_AN_INVOICE_PARA5',
       li2: [
      'EDIT_AN_INVOICE_PARA6',
      'EDIT_AN_INVOICE_PARA7',
      'EDIT_AN_INVOICE_PARA8',
      'EDIT_AN_INVOICE_PARA9',
     ],
    category: 'general'
  },
    {
      id: '57',
      question: 'INVOICE_AFTER_CREDITED',
      li1: [
        'INVOICE_AFTER_CREDITED_PARA1',
        'INVOICE_AFTER_CREDITED_PARA2'
      ],
      category: 'general',
      answer: ""
    },
  {
    id: '58',
    question: 'FAQ_ACCIDENT_QUESTION',
    answer: 'FAQ_ACCIDENT_ANSWER',
    para2: 'FAQ_ACCIDENT_PARA2',
    li1: ['FAQ_ACCIDENT_LI1_1', 'FAQ_ACCIDENT_LI1_2', 'FAQ_ACCIDENT_LI1_3'],
    para4: 'FAQ_ACCIDENT_PARA4',
    link: 'FAQ_ACCIDENT_LINK_TEXT',
    redirect: 'https://www.trygghansa.se/foretag/skadeanmalan',
    category: 'general'
  },
  {
    id: '59',
    question: 'FAQ_ROT_RUT_DEDUCTION_AMOUNT_QUESTION',
    answer: 'FAQ_ROT_RUT_DEDUCTION_AMOUNT_ANSWER',
    li1: [
      "FAQ_EXT_RUTROT_LI1_1",
      "FAQ_EXT_RUTROT_LI1_2",
      "FAQ_EXT_RUTROT_LI1_3",
    ],
    head: 'FAQ_ROT_RUT_DEDUCTION_AMOUNT_PARA1',
    li2: [
      "FAQ_EXT_RUTROT_LI1_4",
      "FAQ_EXT_RUTROT_LI1_5",
      "FAQ_EXT_RUTROT_LI1_6",
      "FAQ_EXT_RUTROT_LI1_7",
      ],
    category: 'general'
  },
       {
        id: '60',
        question: 'FAQ_CAN_I_DEDUCT_COMPUTER_OR_PHONE_QUESTION',
        answer: 'FAQ_CAN_I_DEDUCT_COMPUTER_OR_PHONE_ANSWER',
        category: 'general'
      },
  {
    id: '62',
    question: 'FAQ_VACATION_PAY_TAX_QUESTION',
    answer: 'FAQ_VACATION_PAY_TAX_ANSWER',
    para1: 'FAQ_VACATION_PAY_TAX_PARA1',
    para2: 'FAQ_VACATION_PAY_TAX_PARA2',
    category: 'general'
  },
  {
    id: '61',
    question: 'FAQ_SPP_PENSION_QUESTION',
    answer: 'FAQ_SPP_PENSION_ANSWER',
    li1: [
      'FAQ_SPP_PENSION_LI1_1',
      'FAQ_SPP_PENSION_LI1_2',
      'FAQ_SPP_PENSION_LI1_3',
      'FAQ_SPP_PENSION_LI1_4'
    ],
    para4: 'FAQ_SPP_PENSION_COMPLEMENT',
    para5: 'FAQ_SPP_PENSION_PARA1',
    para6: 'FAQ_SPP_PENSION_PARA2',
    supportEmail1: 'support@invozio.com',
    support1: 'mailto:support@invozio.com',
    category: 'pension'
  },
  {
    id: '63',
    question: 'FAQ_PAY_INVOICE_QUESTION',
    answer: 'FAQ_PAY_INVOICE_ANSWER',
    li1: [
      'FAQ_PAY_INVOICE_LI1_1',
      'FAQ_PAY_INVOICE_LI1_2',
      'FAQ_PAY_INVOICE_LI1_3'
    ],
    para4: 'FAQ_PAY_INVOICE_CLOSING',
    category: 'general',
    faqCategory: 'payments'
  },
];


export const faqData3: FAQItemExtended[] = [
  {
    title: "FAQ_EXT_1_QUESTION",
    description: "FAQ_EXT_1_DESCRIPTION"
  },
  {
    title: "FAQ_EXT_2_QUESTION",
    description: "FAQ_EXT_2_DESCRIPTION"
  },
  {
    title: "FAQ_EXT_3_QUESTION",
    description: "FAQ_EXT_3_DESCRIPTION"
  },
  {
    title: "FAQ_EXT_4_QUESTION",
    description: "FAQ_EXT_4_DESCRIPTION",
    supportEmail: "support@invozio.com",
    support: "support@invozio.com",
    span: "and we'll fix it."
  },
 
  {
    title: "FAQ_EXT_6_QUESTION",
    description: "FAQ_EXT_6_DESCRIPTION"
  },
  {
    title: "FAQ_EXT_7_QUESTION",
    description: "FAQ_EXT_7_DESCRIPTION"
  },
  {
    title: "FAQ_EXT_8_QUESTION",
    description: "FAQ_EXT_8_DESCRIPTION"
  },

  {
    title: "FAQ_EXT_10_QUESTION",
    description: "FAQ_EXT_10_DESCRIPTION"
  },
  {
    title: "FAQ_EXT_11_QUESTION",
    description: "FAQ_EXT_11_DESCRIPTION",
    para1: "FAQ_EXT_11_PARA1",
    para2: "FAQ_EXT_11_PARA2",
    heading: "What about other expenses?",
    heading1: "How do I document my expenses?",
    para3: "FAQ_EXT_11_PARA3",
    para4: "FAQ_EXT_11_PARA4",
    link: "Skatteverket - Egenanställning.",
    redirect: "https://www.skatteverket.se/privat/skatter/arbeteochinkomst/inkomster/egenanstallning.4.4a47257e143e26725ae2b73.html"
  },
  {
    title: "FAQ_EXT_12_QUESTION",
    description: "FAQ_EXT_12_DESCRIPTION",
    para1: "FAQ_EXT_12_PARA1",
    para2: "FAQ_EXT_12_PARA2",
    para3: "FAQ_EXT_12_PARA3",
    para4: "FAQ_EXT_12_PARA4",
    para5: "FAQ_EXT_12_PARA5",
  },
  {
    title: "FAQ_EXT_13_QUESTION",
    description: "FAQ_EXT_13_DESCRIPTION",
    link: "skatteverket.se",
    redirect: "https://skatteverket.se/privat/etjansterochblanketter/blanketterbroschyrer/blanketter/info/4402.4.3810a01c150939e893f1041a.html"
  },
  {
    title: "FAQ_EXT_14_QUESTION",
    description: "FAQ_EXT_14_DESCRIPTION",
    link: "skatteverket.se",
    redirect: "https://www.skatteverket.se/privat/skatter/arbeteochinkomst/inkomster/egenanstallning.4.4a47257e143e26725ae2b73.html"
  },
  {
    title: "FAQ_EXT_15_QUESTION",
    description: "FAQ_EXT_15_DESCRIPTION",
    para1: "FAQ_EXT_15_PARA1",
    para2: "FAQ_EXT_15_PARA2",
    para3:"FAQ_EXT_15_PARA4",
    para4: "FAQ_EXT_15_PARA3"
  },
  {
    title: "FAQ_EXT_16_QUESTION",
    description: "FAQ_EXT_16_DESCRIPTION",
    supportEmail: "admin@invozio.com .",
    support: "mailto:admin@invozio.com",
    para2: "FAQ_EXT_16_PARA2"
  },
  {
    title: "FAQ_EXT_17_QUESTION",
    description: "FAQ_EXT_17_DESCRIPTION",
    // support: "mailto:support@invozio.com",
  },
  {
    title: "FAQ_EXT_18_QUESTION",
    description: "FAQ_EXT_18_DESCRIPTION",
    para1: "FAQ_EXT_18_PARA1",
    li1: [
      "FAQ_EXT_18_LI1_1",
      "FAQ_EXT_18_LI1_2",
      "FAQ_EXT_18_LI1_3",
      "FAQ_EXT_18_LI1_4",
      "FAQ_EXT_18_LI1_5",
      "FAQ_EXT_18_LI1_6",
      "FAQ_EXT_18_LI1_7",
      "FAQ_EXT_18_LI1_8"
    ],
    para2: "FAQ_EXT_18_PARA2"
  },
  {
    title: "FAQ_EXT_19_QUESTION",
    description: "FAQ_EXT_19_DESCRIPTION",
    para1: "FAQ_EXT_19_PARA1",
    link: "ABOUT_INVOZIO",
    redirect: ABOUT_INVOZIO_REDIRECT
  },
  {
    title: "FAQ_EXT_20_QUESTION",
    description: "FAQ_EXT_20_DESCRIPTION_PARA_1",
    para1: "FAQ_EXT_20_DESCRIPTION_PARA_2",
  },
  {
    title: "FAQ_EXT_21_QUESTION",
    description: "FAQ_EXT_21_DESCRIPTION"
  },
  {
    title: "FAQ_EXT_22_QUESTION",
    description: "FAQ_EXT_22_DESCRIPTION"
  },
  {
    title: "FAQ_EXT_23_QUESTION",
    description: "FAQ_EXT_23_DESCRIPTION"
  },
    {
    title: "FAQ_EXT_24_QUESTION",
    description: "FAQ_EXT_24_DESCRIPTION"
  },{
    title: "FAQ_TAX_FREE_MILEAGE_QUESTION",
    description: "FAQ_TAX_FREE_MILEAGE_DESCRIPTION",
    para1: "FAQ_TAX_FREE_MILEAGE_PARA1",
  }
];

export const faqTaxFreeMileage: FAQItemExtended[] = [
  {
    title: "FAQ_TAX_FREE_MILEAGE_QUESTION",
    description: "FAQ_TAX_FREE_MILEAGE_DESCRIPTION",
    para1: "FAQ_TAX_FREE_MILEAGE_PARA1",
  }
];
